import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IShop } from '@/shared/model/shop.model';
import { buildURLQueryOpts, generateSearchAndQuery } from '@/shared/query/query';
import { IEmailTemplate } from '@/shared/model/email-template.model';
import { IShopSmtp } from '@/shared/model/shop-smtp.model';

const baseApiUrl = 'api/v1/shops';
const baseShopifyUrl = 'api/v1/shopify';
const baseApiUrlTemplate = 'api/v1/templates';
const baseApiUrlSmtp = 'api/v1/emails';

export default class ShopService {
  public find(id: number): Promise<IShop> {
    return new Promise<IShop>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveWithSelectedShop(shop?: any): Promise<any> {
    const queryParams = {};
    const selectedShopId = shop?.id;
    const type = shop?.type;

    if (type === 'SHOP' && selectedShopId) {
      queryParams['id'] = selectedShopId;
    }

    const searchAndQuery = generateSearchAndQuery(null, queryParams);

    return this.retrieve(null, { ...searchAndQuery });
  }

  public retrieve(paginationQuery?: any, searchQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}&${buildURLQueryOpts(searchQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public smtpTest(entity: IShopSmtp): Promise<IShopSmtp> {
    return new Promise<IShopSmtp>((resolve, reject) => {
      axios
        .post(`${baseApiUrlSmtp}/test-smtp`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public preview(entity?: any, subject?: any, headerFooter?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrlTemplate}/preview`, { bodyTemplate: entity, ...subject, ...headerFooter })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveIdentifier(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrlTemplate + `/identifiers`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveTemplateByIdentifierAndShopId(shopId?: number, identifier?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${shopId}/templates?identifier=${identifier}`)
        .then(res => {
          console.log('Shop service template', res);
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveTemplateByShopId(shopId?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${shopId}/templates`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public deleteShopEmailTemplate(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrlTemplate}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IShop): Promise<IShop> {
    return new Promise<IShop>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createShopEmailTemplate(id?: number, entity?: any, shop?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/${id}/templates`, { data: shop ? entity : [entity] })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IShop): Promise<IShop> {
    const { id } = entity;
    return new Promise<IShop>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public updateShopEmailTemplate(id: number, entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .put(`${baseApiUrlTemplate}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public connectShopify(id: number): void {
    const redirectUri = window.location.href;
    window.location.href = `${baseShopifyUrl}/authenticate?shopId=${id}&redirectUri=${redirectUri}`;
  }

  public disconnectShopify(id: number): Promise<IShop> {
    return new Promise<IShop>((resolve, reject) => {
      axios
        .delete(`${baseShopifyUrl}/authenticate?shopId=${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
